import { useAuthorization } from '~/composables/useAuthorization'
import {
  ALL_MARKETS,
  SUBSCRIPTION_BRIEFING_COPPER,
  SUBSCRIPTION_FORECASTS_COPPER,
  SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES,
  SUBSCRIPTION_FORECASTS_NEW_TECHNOLOGY,
  SUBSCRIPTION_FORECASTS_RECYCLING,
  SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT,
  SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS,
  SUBSCRIPTION_SERVICE_COPPER,
} from '~/constants/services/constants'

const copperSubscriptions = [
  SUBSCRIPTION_FORECASTS_COPPER,
  SUBSCRIPTION_BRIEFING_COPPER,
  SUBSCRIPTION_SERVICE_COPPER,
]

const subscriptionsByMarkets = {
  copper: copperSubscriptions,
  ['new-technology']: [SUBSCRIPTION_FORECASTS_NEW_TECHNOLOGY],
  ['battery-gigafactory']: [
    SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES,
    SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT,
  ],
  recycling: [
    SUBSCRIPTION_FORECASTS_RECYCLING,
    SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS,
  ],
}

export default defineNuxtRouteMiddleware(async (to) => {
  const { hasMemberships } = useAuthorization()
  const { marketSlug } = to.meta

  const selectedMarket = ALL_MARKETS.find(
    (market) =>
      market.slug === marketSlug || market.alternativeSlug === marketSlug,
  )

  if (!selectedMarket) return

  const slug = selectedMarket.alternativeSlug ?? selectedMarket.slug
  const premiumMarketPath = `/${slug}/portal`
  const toPath = to.path.replace(/\/$/, '')

  const hasActiveMembership = await hasMemberships(subscriptionsByMarkets[slug])

  if (hasActiveMembership && toPath === premiumMarketPath) return

  if (hasActiveMembership) {
    return navigateTo(premiumMarketPath, { redirectCode: 302 })
  }
})
